import { createFileRoute } from "@tanstack/react-router"
import { usePageTracking } from "~/hooks/usePageTracking"
import GreigePlanningTab from "~/components/purchase-plan/GreigePlanningTab"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/$purchasePlanId/_layout/greige",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Supply Plan - Greige")
  return <GreigePlanningTab />
}
